module.exports = __webpack_public_path__ + "img/124x124.2189e27f.png";